<template>
    <component
        @changeDate="changeDateHandler"
        :is="componentName"
        :items="item.dateList"
        :centered="true"
        :loading="loading"
        :isCustomActivatorEvent='true'
    >
        <template v-slot:activator="{ onActivate }" >
            <Question
                :question="question"
                :answers="answers"
                @select="onActivate"
            />
        </template>
    </component>
</template>

<script>
import Question from '../Question';
import CustomDataPicker from '../../bucket/components/CustomDataPicker';
import ListDataPicker from '../../bucket/components/ListDataPicker';

export default {
    name: 'ReScheduleQuestion',
    props: {
        item: {
            type: Object,
            required: true,
        },
        loading: Boolean,
    },
    data: () => ({
        answers: [
            { key: 'schedule', text: 'Выбрать новую дату' },
        ],
    }),
    computed: {
        question() {
            if (this.item.educationType === 'rsv_webinar') {
                return 'Вебинар не пройден.\n' +
                    'Обучение будет удалено из плана.';
            }
            return 'Запланированное обучение не пройдено';
        },
        componentName() {
            return (this.item.isAnyTimeStart)
                ? 'CustomDataPicker'
                : 'ListDataPicker';
        },
    },
    methods: {
        changeDateHandler(date) {
            this.$emit('action', { key: 'schedule', date: date });
        },
    },
    components: {
        Question,
        CustomDataPicker,
        ListDataPicker,
    },
};
</script>

<style scoped lang="scss">
</style>